import Card from '@/components/ui/Card'
import ContentWrapper from '@/components/ui/ContentWrapper'
import { Link } from '@/i18n/routing'
import { IconArrowRight } from '@tabler/icons-react'
import { situations } from './situations'

type SituationCardsProps = {
  locale: string
  /** compact: Startseite, mit Link auf die Uebersicht. full: /wo-wir-helfen. */
  variant?: 'compact' | 'full'
  className?: string
}

// Ohne 'use client' und ohne Hooks, damit dieselbe Komponente in der
// Client-Startseite und in der Server-Seite /wo-wir-helfen laeuft.
const SituationCards = ({ locale, variant = 'full', className = 'mt-24 lg:mt-32' }: SituationCardsProps) => {
  const lang = locale === 'en' ? 'en' : 'de'
  const isCompact = variant === 'compact'

  return (
    <ContentWrapper tag="section" className={className}>
      {isCompact && (
        <div className="col-span-full mb-12">
          <p className="text-accent text-sm uppercase tracking-[0.2em] mb-4">{lang === 'en' ? 'How we help' : 'Wo wir helfen'}</p>
          <h2 className="text-white text-2xl lg:text-[2.5rem] leading-tight">
            {lang === 'en' ? 'Which of these sounds' : 'Welche Lage kennen'} <span className="text-accent">{lang === 'en' ? 'familiar?' : 'Sie?'}</span>
          </h2>
        </div>
      )}
      <ol className="col-span-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
        {situations.map((situation, index) => (
          <li key={situation.id} id={isCompact ? undefined : situation.id} className="scroll-mt-32">
            <Card className="bg-KMRS-Darkmode border border-accent p-8 h-full flex flex-col">
              <p className="text-white/60 text-sm mb-4">
                <span className="text-accent font-medium">{String(index + 1).padStart(2, '0')}</span> · {situation.kicker[lang]}
              </p>
              <h3 className="text-white font-medium text-xl leading-snug mb-4">{situation.title[lang]}</h3>
              {!isCompact && <p className="text-white/80 leading-6 mb-6">{situation.text[lang]}</p>}
              {/* Pfeil inline statt Flex: bricht der Text um, bleibt er am Wortende statt rechts aussen */}
              <Link href={situation.href} className="mt-auto text-accent font-medium hover:underline">
                {situation.linkLabel[lang]}&nbsp;
                <IconArrowRight size={18} aria-hidden="true" className="inline align-[-3px]" />
              </Link>
            </Card>
          </li>
        ))}
        {isCompact && (
          <li>
            <Card className="bg-accent p-8 h-full flex flex-col justify-between gap-6">
              <p className="text-white font-medium text-xl leading-snug">
                {lang === 'en' ? 'Not sure where you stand? We sort it out with you in 30 minutes.' : 'Nicht sicher, wo Sie stehen? Wir ordnen es in 30 Minuten mit Ihnen ein.'}
              </p>
              <Link href="/wo-wir-helfen" className="inline-flex items-center gap-3 text-white font-medium hover:underline">
                {lang === 'en' ? 'All situations' : 'Alle Situationen'} <IconArrowRight size={18} aria-hidden="true" />
              </Link>
            </Card>
          </li>
        )}
      </ol>
    </ContentWrapper>
  )
}

export default SituationCards
